// extracted by mini-css-extract-plugin
export default {"basecard":"baseCard_basecard__AynKa","base-card-title":"baseCard_base-card-title__239Pu","base-card-footer":"baseCard_base-card-footer__vDmBM"};